import { useCallback } from 'react';
import { useMutation, useQueryClient, type QueryKey } from '@tanstack/react-query';
import { actionOptions } from './action-options';

/** A stable imperative trigger for forms that already own their busy/error presentation. */
export function useApiAction<Args extends unknown[], Result>(
  action: (...args: Args) => Promise<Result>,
  invalidates: readonly QueryKey[] = [],
) {
  const qc = useQueryClient();
  const { mutateAsync } = useMutation(actionOptions(qc, action, invalidates));
  return useCallback((...args: Args) => mutateAsync(args), [mutateAsync]);
}
